// cart-utilities.js

// Check if a product exists in the cart by product ID
function checkProductInCart(productId) {
    if (!window.cartData || !window.cartData.items) {
        console.error('Cart data is not loaded yet.');
        return false;
    }
    return window.cartData.items.some(item => item.product_id === productId);
}

// Remove a product from the cart by product ID
function removeProductFromCart(productId) {
    if (!window.cartData || !window.cartData.items) {
        console.error('Cart data is not loaded yet.');
        return;
    }

    const product = window.cartData.items.find(item => item.product_id === productId);

    if (product) {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: product.key, // Use the unique line item key
                quantity: 0 // Set quantity to 0 to remove the product
            })
        })
            .then(response => response.json())
            .then(updatedCart => {
                console.log('Product removed successfully:', updatedCart);
                updateCartUI(updatedCart); // Update UI after removing product
                window.cartData = updatedCart; // Update the global cart data
                location.reload();
            })
            .catch(error => console.error('Error removing product:', error));
    } else {
        console.log('Product not found in cart.');
    }
}

// Update the cart UI dynamically
function updateCartUI(updatedCart) {
    const cartCountElement = document.querySelector('.cart-count');
    if (cartCountElement) {
        cartCountElement.textContent = updatedCart.item_count;
    }
}

// Load the cart data
function loadCartData() {
    return fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            window.cartData = cart; // Set global cart data
            console.log('Cart data loaded:', cart);
        })
        .catch(error => console.error('Error loading cart data:', error));
}

// Example usage: Check and remove a specific product by ID
function checkAndRemoveProduct(productId) {
    if (!window.cartData || !window.cartData.items) {
        console.error('Cart data is not loaded yet. Loading now...');
        loadCartData().then(() => {
            // Retry after loading cart data
            if (checkProductInCart(productId)) {
                removeProductFromCart(productId);
            } else {
                console.log('Product is not in the cart.');
            }
        });
    } else {
        if (checkProductInCart(productId)) {
            removeProductFromCart(productId);
        } else {
            console.log('Product is not in the cart.');
        }
    }
}

// Ensure cart data is loaded on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
    loadCartData();
});
